<template>
  <div class="main_wrap">
    <!-- 活动标题 -->
    <div v-wechat-title="'《魔卡少女樱：回忆钥匙》摇一摇领奖'"></div>

    <Header
      v-if="true"
      :isOnline="0"
      :isShake="true"
      :isVip="true"
      :config="headerConfig"
      :isShowInfo="true"
    />

    <div class="first-page">
      <div class="detail" @click="isShowRules = true"></div>
      <!-- 添加成功 -->
      <div class="success" v-if="isSuccess"></div>
      <!-- 添加失败 -->
      <div class="fail" v-if="isFail"></div>
      <!-- 已添加 -->
      <div class="added" v-if="isAdded"></div>
      <!-- 未添加 -->
      <div class="fillout" v-if="isFillout">
        <div class="phone_wrap">
          <input type="text" v-model="phone" placeholder="请输入您的微信号" />
        </div>
        <div class="submit" @click="showDialog"></div>
      </div>
    </div>
    <Footer :gameName="gameName"></Footer>

    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
    ></Os>

    <!-- 登记信息弹窗 -->
    <div class="address-wrap popup_wrap" v-show="isShowAddress">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="address-box popup_wrap-box" v-show="isShowAddress">
          <div class="info">您的微信号为{{ phone }}是否提交？</div>
          <div class="cancel" @click="closeAddress"></div>
          <div class="affirm" @click="submitInfo"></div>
          <div class="close" @click="closeAddress"></div>
          <div class="close-bg" @click="closeAddress"></div>
        </div>
      </transition>
    </div>

    <!-- 活动规则弹窗 -->
    <div class="rules-wrap popup_wrap" v-show="isShowRules">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        :duration="{ enter: 1000 }"
      >
        <div class="rules-box popup_wrap-box" v-show="isShowRules">
          <div class="close" @click="isShowRules = false"></div>
          <div class="close-bg" @click="isShowRules = false"></div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import { onGetInitDataAPI, submitInfoApi, secretFreeLoginApi } from "../api";
import { buriedLogger, getTimeStamp } from "@/utils/utils";

export default {
  name: "sakura-vip",
  components: {
    Header,
    Footer,
    Login,
    Os
  },

  data() {
    return {
      headerConfig,
      gameName: "sakura",
      downloadUrl: "https://sakura.qingcijoy.com/official/index.html",
      isShowAddress: false, // 登记信息弹窗
      isShowRules: false, // 活动规则弹窗
      isSuccess: false, // 添加成功
      isFail: false, // 添加失败
      isAdded: false, // 已添加
      isFillout: false, // 未填写
      // 其他数据
      loginTypes: ["sms", "password"],
      // 微信号码
      phone: "",
      // 游戏传过来的参数↓
      game_id: "",
      role_id: "",
      sign: "",
      token: "",
      server_id: "",
      // 游戏传过来的参数↑
      isSubmit: false // 通过提交接口的
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    if (
      this.$route.query.game_id &&
      this.$route.query.role_id &&
      this.$route.query.token
    ) {
      this.game_id = this.$route.query.game_id;
      this.role_id = this.$route.query.role_id;
      this.sign = this.$route.query.sign;
      this.token = this.$route.query.token;
      this.server_id = this.$route.query.server_id;
      this.secretFreeLogin();
    } else {
      this.initData();
    }

    // 埋点
    const bl = buriedLogger("sakura", "小樱_VIP专属客服");
    this.logger = bl;
  },
  mounted() {},
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.isSubmit = false;
          this.isSuccess = false;
          this.isFail = false;
          this.isAdded = false;
          this.isFillout = true;
          this.phone = "";
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
          this.isSubmit = false;
          this.isSuccess = false;
          this.isFail = false;
          this.isAdded = false;
          this.isFillout = false;
          if (!newValue.wechat_num) {
            this.isFillout = true;
          } else {
            this.isFillout = false;
            if (this.isSubmit) {
              this.isSuccess = true;
            } else {
              this.isAdded = true;
            }
          }
        }
      }
    }
  },
  methods: {
    // 初始化接口
    initData() {
      onGetInitDataAPI().then(response => {
        if (response.code == 402) {
          this.onToast(response.message);
        }
        this.onInitDataCallback(response);
        this.setUserInfo(response.data.userinfo);
        this.setActiveInfo(response.data.activity);
        if (
          !response.data ||
          !response.data.userinfo ||
          !response.data.userinfo.wechat_num
        ) {
          this.isFillout = true;
        } else {
          this.isFillout = false;
          if (this.isSubmit) {
            this.isSuccess = true;
          } else {
            this.isAdded = true;
          }
        }
      });
    },
    // 提交信息接口请求
    submitInfo() {
      let params = { wechat_num: this.phone };
      submitInfoApi(params).then(response => {
        if (response.code == 200) {
          this.isSubmit = true;
          this.isShowAddress = false;
          this.initData();
          this.logger.sum("小樱_VIP专属客服_信息登记成功");
        } else {
          this.logger.sum("小樱_VIP专属客服_信息登记成功");
          this.onToast(response.message);
        }
      });
    },
    // 免密登录请求
    secretFreeLogin() {
      let params = {
        game_id: this.game_id,
        role_id: this.role_id,
        sign: this.sign,
        token: this.token,
        server_id: this.server_id
      };
      secretFreeLoginApi(params).then(response => {
        if (response.code == 200) {
          this.initData();
          this.logger.sum("小樱_VIP专属客服_免密登录成功");
          setTimeout(() => {
            window.location.href = `https://h5.qingcigame.com/sakura/vip/enter${getTimeStamp()}`;
          }, 200);
        } else {
          this.logger.sum("小樱_VIP专属客服_免密登录失败");
          this.onToast(response.message);
        }
      });
    },
    // 打开提交二次确认弹窗
    showDialog() {
      if (!this.userInfo.role_id) {
        return this.changeLoginPopup(true);
      }
      const re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      let result = re.test(this.phone);
      if (!this.phone) {
        return this.onToast("请输入您的手机号");
      } else if (!result) {
        return this.onToast("请输入正确的手机号");
      }
      this.isShowAddress = true;
    },
    // 关闭登记信息弹窗
    closeAddress() {
      this.isShowAddress = false;
    },
    // 选择角色后
    selectCallback() {
      this.initData();
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {},
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger",
      "setUserInfo",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/vip/index/index.vue